module.exports = __webpack_public_path__ + "static/media/box-desafio-quiz.e50efa5a.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/desafios/box-desafio-quiz.png
// module id = 1250
// module chunks = 0